if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.viewer = this.querySelector('[id^="GalleryViewer"]');
      this.slider = this.querySelector('[id^="Slider-Gallery"]') || this.viewer;
      this.thumbnails = this.querySelector('[id^="GalleryThumbnails"]');
      this.thumbnailList = this.thumbnails ? this.thumbnails.querySelector('[id^="Slider-Thumbnails"]') : null;
      this.scrollTimer = null;

      if (!this.slider) return;

      if (this.thumbnails) {
        this.thumbnails.querySelectorAll('[data-target]').forEach((thumbnail) => {
          const button = thumbnail.querySelector('button');
          if (!button) return;
          button.addEventListener('click', (event) => {
            event.preventDefault();
            this.setActiveMedia(thumbnail.dataset.target, false);
          });
        });

        this.thumbnails.querySelectorAll('.slider-button').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            if (!this.thumbnailList) return;
            const direction = button.name === 'previous' ? -1 : 1;
            const amount = Math.max(this.thumbnailList.clientWidth * 0.7, 180);
            this.thumbnailList.scrollBy({ left: direction * amount, behavior: 'smooth' });
          });
        });
      }

      this.querySelectorAll('.slider-buttons > button[name="previous"], .slider-buttons > button[name="next"]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.moveRelative(button.name === 'previous' ? -1 : 1);
        });
      });

      this.slider.addEventListener('scroll', () => {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => this.syncFromScroll(), 120);
      }, { passive: true });

      const current = this.slider.querySelector('.product__media-item.is-active') || this.slider.querySelector('.product__media-item:not(.hidden)');
      if (current) this.updateState(current.dataset.mediaId, false);
    }

    visibleMedia() {
      return Array.from(this.slider.querySelectorAll('.product__media-item[data-media-id]')).filter((item) => !item.classList.contains('hidden'));
    }

    moveRelative(direction) {
      const items = this.visibleMedia();
      if (!items.length) return;
      const currentIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
      const nextIndex = Math.min(items.length - 1, Math.max(0, currentIndex + direction));
      this.setActiveMedia(items[nextIndex].dataset.mediaId, false);
    }

    syncFromScroll() {
      const items = this.visibleMedia();
      if (!items.length) return;
      const targetLeft = this.slider.scrollLeft;
      let closest = items[0];
      let distance = Math.abs(items[0].offsetLeft - targetLeft);
      items.forEach((item) => {
        const candidate = Math.abs(item.offsetLeft - targetLeft);
        if (candidate < distance) {
          distance = candidate;
          closest = item;
        }
      });
      this.updateState(closest.dataset.mediaId, false);
    }

    setActiveMedia(mediaId, prepend = false, filtering = false, currentVariant = null) {
      if (!mediaId || !this.slider) return;

      if (filtering && currentVariant && this.dataset.filteringOption) {
        const selected = currentVariant[this.dataset.filteringOption];
        this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link').forEach((item) => {
          if (!item.dataset.alt || item.dataset.alt === selected || item.dataset.alt === 'always_display') item.classList.remove('hidden');
          else item.classList.add('hidden');
        });
      }

      const safeId = String(mediaId).replace(/"/g, '\\"');
      const activeMedia = this.slider.querySelector(`[data-media-id="${safeId}"]`);
      if (!activeMedia) return;

      if (prepend && this.dataset.disablePrepend !== 'true') {
        this.slider.prepend(activeMedia);
        if (this.thumbnailList) {
          const activeThumb = this.thumbnailList.querySelector(`[data-target="${safeId}"]`);
          if (activeThumb) this.thumbnailList.prepend(activeThumb);
        }
      }

      this.updateState(mediaId, true);

      const left = Math.max(0, activeMedia.offsetLeft);
      if (typeof this.slider.scrollTo === 'function') this.slider.scrollTo({ left, behavior: 'smooth' });
      else activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

      this.playActiveMedia(activeMedia);
    }

    updateState(mediaId, scrollThumbnail = true) {
      const safeId = String(mediaId).replace(/"/g, '\\"');
      const activeMedia = this.slider.querySelector(`[data-media-id="${safeId}"]`);
      if (!activeMedia) return;

      this.slider.querySelectorAll('.product__media-item[data-media-id]').forEach((item) => item.classList.remove('is-active'));
      activeMedia.classList.add('is-active');

      if (this.thumbnails) {
        this.thumbnails.querySelectorAll('button[aria-current]').forEach((button) => button.removeAttribute('aria-current'));
        const activeThumb = this.thumbnails.querySelector(`[data-target="${safeId}"]`);
        if (activeThumb) {
          const button = activeThumb.querySelector('button');
          if (button) button.setAttribute('aria-current', 'true');
          if (scrollThumbnail && this.thumbnailList && typeof this.thumbnailList.scrollTo === 'function') {
            this.thumbnailList.scrollTo({ left: Math.max(0, activeThumb.offsetLeft - 12), behavior: 'smooth' });
          }
        }
      }

      const items = this.visibleMedia();
      const position = items.findIndex((item) => item === activeMedia) + 1;
      this.querySelectorAll('.slider-counter--current').forEach((counter) => {
        if (position > 0) counter.textContent = position;
      });
    }

    playActiveMedia(activeItem) {
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia && typeof deferredMedia.loadContent === 'function') deferredMedia.loadContent(false);
    }
  });
}
